import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Cookie } from "lucide-react";
import { useLang } from "../../i18n/LangContext";
import { PRIVACY } from "../../i18n/privacy";
import { INTRO_DELAY } from "./Preloader";

export const CookieNotice = () => {
  const { lang } = useLang();
  const p = PRIVACY[lang];
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (localStorage.getItem("lf-cookie-notice") === "1") return undefined;
    const t = setTimeout(() => setShow(true), (INTRO_DELAY + 1.2) * 1000);
    return () => clearTimeout(t);
  }, []);

  const close = () => {
    localStorage.setItem("lf-cookie-notice", "1");
    setShow(false);
  };

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          data-testid="cookie-notice"
          role="dialog"
          aria-live="polite"
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 40 }}
          transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
          className="fixed inset-x-3 bottom-3 z-[70] rounded-2xl border border-stone-700 bg-[#1C1917]/95 p-5 text-stone-200 shadow-2xl backdrop-blur-md sm:inset-x-auto sm:bottom-6 sm:right-6 sm:max-w-sm"
        >
          <div className="flex gap-3">
            <Cookie size={18} className="mt-0.5 shrink-0 text-[#E9B79F]" />
            <p className="text-sm leading-relaxed">{p.notice}</p>
          </div>
          <div className="mt-4 flex items-center justify-between gap-4">
            <Link to="/privacy" onClick={close} data-testid="cookie-notice-more" className="text-sm text-stone-300 underline underline-offset-4 transition-colors hover:text-[#FBF9F5]">
              {p.noticeMore}
            </Link>
            <button onClick={close} data-testid="cookie-notice-ok" className="rounded-full bg-[#FBF9F5] px-5 py-2 text-sm font-medium text-[#1C1917] transition-colors duration-300 hover:bg-[#C85A32] hover:text-[#FBF9F5]">
              {p.noticeOk}
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
